/**
 * Uproszczony model (DTO) reprezentujący zakres godzinowy w danym dniu tygodnia.
 * Pozbawiony flag interfejsu użytkownika (takich jak isFullDay).
 */
export class ReservationDhJson {

  /** * Indeks dnia tygodnia.
   * Pozwala na cykliczne aplikowanie reguły w harmonogramie.
   */
  public dayIdx: number;

  /** * Godzina rozpoczęcia bloku czasowego (w formacie "HH:mm").
   */
  public startTime: string;

  /** * Godzina zakończenia bloku czasowego (w formacie "HH:mm").
   */
  public endTime: string;

  constructor() {
  }

}
